import { render, staticRenderFns } from "./RoleSelection.vue?vue&type=template&id=5215b09f&"
import script from "./RoleSelection.vue?vue&type=script&lang=js&"
export * from "./RoleSelection.vue?vue&type=script&lang=js&"
import style0 from "./RoleSelection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VProgressCircular})
